import {Injectable} from '@angular/core';
import {PolizzeBuchungDetail} from '@pezi/entities';
import {PolizzeBuchungResult} from '@pezi/entities/dist/src/main/ts/models/generated/polizze/polizzebuchungresult';
import {createStore, withProps} from "@ngneat/elf";
import {persistState, sessionStorageStrategy} from "@ngneat/elf-persist-state";

export interface ActivePolizzebuchungState {
  polizzebuchung: PolizzeBuchungDetailCallerWithPolint;
  loading: boolean;
  errorLoading: boolean;
  otherBuchungenLoading: boolean;
  otherBuchungen: PolizzeBuchungResult[];
}

export function createInitialState(): ActivePolizzebuchungState {
  return {
    polizzebuchung:        undefined,
    loading:               false,
    errorLoading:          false,
    otherBuchungenLoading: false,
    otherBuchungen:        undefined
  };
}

export interface PolizzeBuchungDetailCallerWithPolint extends PolizzeBuchungDetail {
  callerPolintS?: number;
}

@Injectable({providedIn: 'root'})
export class ActivePolizzebuchungStore {

  data = createStore({name: 'active-polizzebuchung'}, withProps<ActivePolizzebuchungState>(createInitialState()));
  persist = persistState(this.data, {
    key: 'active-polizzebuchung',
    storage: sessionStorageStrategy,
  });

}

